const VM_DESKTOP_PANEL_MIN_WIDTH = 540;
const VM_DESKTOP_PANEL_MAX_WIDTH = 1_200;
const VM_DESKTOP_PANEL_VIEWPORT_FRACTION = 0.47;

/** Cursor-like default: the mirrored desktop owns roughly half a wide screen. */
export function getVmDesktopPanelDefaultWidth(viewportWidth: number): number {
  const width = Math.round(viewportWidth * VM_DESKTOP_PANEL_VIEWPORT_FRACTION);
  return Math.max(VM_DESKTOP_PANEL_MIN_WIDTH, Math.min(VM_DESKTOP_PANEL_MAX_WIDTH, width));
}
